import { render } from "./FicheProduitPage.vue?vue&type=template&id=5f5bb44a&ts=true"
import script from "./FicheProduitPage.vue?vue&type=script&lang=ts"
export * from "./FicheProduitPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__